import { Modal } from 'antd'
import { useEffect, useRef, useState } from 'react'

import AtomButton from '@/components/Atoms/AtomButton/AtomButton'

import { PRIVACY_POLICY_SECTIONS } from '../PrivacyPolicyContent'
import cn from './PrivacyPolicyModal.module.scss'

type PrivacyPolicyModalProps = {
  open: boolean
  onAccept: () => void
  onClose: () => void
}

function PrivacyPolicyModal({
  open,
  onAccept,
  onClose,
}: PrivacyPolicyModalProps) {
  const [scrolledToBottom, setScrolledToBottom] = useState(false)
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (open) {
      setScrolledToBottom(false)
      const timer = setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = 0
        }
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [open])

  const renderTextWithLinks = (text: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g
    const parts = text.split(urlRegex)
    return parts.map((part, i) =>
      urlRegex.test(part) ? (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className={cn.link}
        >
          {part}
        </a>
      ) : (
        part
      )
    )
  }

  const handleScroll = () => {
    const el = scrollRef.current
    if (!el) return
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 32
    setScrolledToBottom(atBottom)
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <div className={cn.modalTitle}>
          Поручение на обработку персональных данных
        </div>
      }
      styles={{
        header: { paddingBottom: 12, borderBottom: '1px solid #f0f0f0' },
        body: { padding: 0 },
      }}
      width={720}
      footer={
        <div className={cn.footer}>
          {!scrolledToBottom && (
            <span className={cn.scrollHint}>
              Прокрутите до конца, чтобы принять
            </span>
          )}
          <div className={cn.footerButtons}>
            <AtomButton variant="secondary" onClick={onClose}>
              Закрыть
            </AtomButton>
            <AtomButton
              disabled={!scrolledToBottom}
              onClick={() => {
                onAccept()
                onClose()
              }}
            >
              Принять
            </AtomButton>
          </div>
        </div>
      }
    >
      <div className={cn.scrollBody} ref={scrollRef} onScroll={handleScroll}>
        {PRIVACY_POLICY_SECTIONS.map((section, i) =>
          section.type === 'heading' ? (
            <h3 key={i} className={cn.sectionHeading}>
              {section.text}
            </h3>
          ) : (
            <p key={i} className={cn.paragraph}>
              {renderTextWithLinks(section.text)}
            </p>
          )
        )}
        <div className={cn.endMarker} />
      </div>
    </Modal>
  )
}

export default PrivacyPolicyModal
